export const cilTrash = ["24 24","<path d='M4.5 22.125c-0 0.003-0 0.006-0 0.008 0 0.613 0.494 1.11 1.105 1.116h12.79c0.612-0.006 1.105-0.504 1.105-1.117 0-0.003-0-0.006-0-0.009v0-15h-15zM6 8.625h12v13.125h-12z'></path><path d='M7.875 10.125h1.5v9.375h-1.5v-9.375z'></path><path d='M11.25 10.125h1.5v9.375h-1.5v-9.375z'></path><path d='M14.625 10.125h1.5v9.375h-1.5v-9.375z'></path><path d='M15.375 4.125v-2.25c0-0.631-0.445-1.125-1.013-1.125h-4.725c-0.568 0-1.013 0.494-1.013 1.125v2.25h-5.625v1.5h18v-1.5zM10.125 2.25h3.75v1.875h-3.75z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-trash.js
// module id = null
// module chunks = 